/*
 * Soft per-element reveal on scroll, from the approved concept.
 * Gated on a class this script adds, so the page is fully visible without JS
 * (and in the theme editor, which re-renders sections after load).
 */
(function () {
  var root = document.documentElement;
  root.classList.add('hs-js');

  var SELECTOR = '.hs [data-hs-reveal] > *, .hs .hs-pola, .hs .hs-vs__card';

  function observe(scope) {
    var els = [].slice.call((scope || document).querySelectorAll(SELECTOR));
    els.forEach(function (el) {
      if (el.classList.contains('hs-reveal')) return;
      el.classList.add('hs-reveal');
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hs-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hs-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // The design diagram reveals its callouts one at a time. All the timing lives
  // in CSS (each group carries its own --hs-delay); this only decides WHEN the
  // sequence starts — once, when the diagram is properly in view rather than
  // just peeking over the fold, so the tour is not half over before it is read.
  // Observe .hs-dg, NOT .hs-dg__stage. The mobile legend is a SIBLING of the
  // stage, so a class on the stage never reaches it — which left every callout
  // description invisible on mobile while the desktop labels were fine.
  function observeDiagram(scope) {
    var stages = [].slice.call((scope || document).querySelectorAll('.hs-dg'));
    if (!('IntersectionObserver' in window)) {
      stages.forEach(function (el) { el.classList.add('hs-dg--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hs-dg--in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    stages.forEach(function (el) { io.observe(el); });
  }

  observe(document);
  observeDiagram(document);

  // Theme editor: a re-rendered section arrives after load with no reveal state.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    observeDiagram(e.target);
  });
})();
